import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import ClickOutside from 'decorators/click_outside/click_outside_decorator'
import quickLaunchIcon from 'assets/components/main_topbar/quick-launch-icon.svg'
import QuickLaunchDropdown from './quickLaunchDropdown'
import { localize } from 'helpers/translator'
import { HintTooltip } from 'components/tooltip'
import TopbarButton from 'components/topbar/main/button/topbar_button'

import QuickLaunchTooltipImage from 'assets/components/main_topbar/quick-launch-tooltip.svg'

import styles from './quickLaunch.scss'

class QuickLaunch extends PureComponent {
	constructor(props) {
		super(props)

		this.state = {
			visible: false,
		}
	}

	toggleQuickLaunch = () => {
		this.props.handleQuickLaunchIconToggled()

		this.setState(prevState => ({
			visible: !prevState.visible,
		}))
	}

	closeQuickLaunch = () => {
		if (this.state.visible) {
			this.toggleQuickLaunch()
		}
	}

	onTimerSelection = () => {
		this.closeQuickLaunch()
		this.props.onTimerSelection()
	}

	onCollaborateSelection = () => {
		this.closeQuickLaunch()
		this.props.onCollaborateSelection()
	}

	renderQuickLaunch = () => {
		const {
			onDrawItSelection,
			onOeqSelection,
		} = this.props

		const {
			shouldShowQuickLaunchDrawIt,
			shouldShowQuickLaunchFieldTrip,
			shouldShowQuickLaunchOeq,
			shouldShowQuickLaunchCollaborate,
			shouldShowQuickLaunchTimer,
			shouldShowQuickLaunchTooltip,
		} = this.props.quickLaunchData

		if (shouldShowQuickLaunchTooltip) {
			return (
				<div styleName='right-nav-item-tooltip'>
					<HintTooltip
						type='tooltipQuickLaunch'
						hintText={localize('topbar_quickLaunch_tooltip_text')}
						hintButton={localize('topbar_quickLaunch_tooltip_button')}
						arrowPosition='top-right'
						centeredContent
						headerImage={QuickLaunchTooltipImage}
						onButtonClick={this.closeTooltip}
					>
					</HintTooltip>
				</div>
			)
		}
		return (
			<div styleName='right-nav-item-dropdown right-nav-item-dropdown--wide'>
				<QuickLaunchDropdown
					shouldShowQuickLaunchDrawIt={shouldShowQuickLaunchDrawIt}
					shouldShowQuickLaunchFieldTrip={
						shouldShowQuickLaunchFieldTrip
					}
					shouldShowQuickLaunchOeq={shouldShowQuickLaunchOeq}
					shouldShowQuickLaunchCollaborate={
						shouldShowQuickLaunchCollaborate
					}
					shouldShowQuickLaunchTimer={shouldShowQuickLaunchTimer}
					onDrawItSelection={onDrawItSelection}
					onCollaborateSelection={this.onCollaborateSelection}
					onOeqSelection={onOeqSelection}
					onTimerSelection={this.onTimerSelection}
				/>
			</div>
		)
	}

	render() {
		const { shouldShowQuickLaunch } = this.props.quickLaunchData

		if (!shouldShowQuickLaunch) {
			return null
		}

		return (
			<ClickOutside clickOutsideHandler={this.closeQuickLaunch}>
				<div styleName='right-nav-item'>
					<TopbarButton
						icon={quickLaunchIcon}
						label={localize('main_topBar_quickLaunchButton_label')}
						buttonHandler={this.toggleQuickLaunch}
						isActive={this.state.visible}
					/>
					{ this.state.visible && this.renderQuickLaunch() }
				</div>
			</ClickOutside>
		)
	}
}

QuickLaunch.defaultProps = {
	quickLaunchData: {
		shouldShowQuickLaunch: false,
		shouldShowQuickLaunchDrawIt: false,
		shouldShowQuickLaunchFieldTrip: false,
		shouldShowQuickLaunchOeq: false,
		shouldShowQuickLaunchCollaborate: false,
		shouldShowQuickLaunchTimer: false,
		shouldShowQuickLaunchTooltip: false,
	},
	handleQuickLaunchIconToggled: () => {},
	onDrawItSelection: () => {},
	onCollaborateSelection: () => {},
	onOeqSelection: () => {},
	onTimerSelection: () => {},
}

QuickLaunch.propTypes = {
	quickLaunchData: PropTypes.shape({
		shouldShowQuickLaunch: PropTypes.bool,
		shouldShowQuickLaunchDrawIt: PropTypes.bool,
		shouldShowQuickLaunchFieldTrip: PropTypes.bool,
		shouldShowQuickLaunchOeq: PropTypes.bool,
		shouldShowQuickLaunchCollaborate: PropTypes.bool,
		shouldShowQuickLaunchTimer: PropTypes.bool,
		shouldShowQuickLaunchTooltip: PropTypes.bool,
	}).isRequired,
	handleQuickLaunchIconToggled: PropTypes.func,
	onDrawItSelection: PropTypes.func,
	onCollaborateSelection: PropTypes.func,
	onOeqSelection: PropTypes.func,
	onTimerSelection: PropTypes.func,
}

export default CSSModules(QuickLaunch, styles, {allowMultiple: true})
